module.exports = __webpack_public_path__ + "5c0a1e400969f4dec0d5eb8a4550e945.png";